import { HttpLink } from '@apollo/client';

interface contentfulLinkOptions {
  accessToken?: string;
  environment?: string;
  preview?: boolean;
  previewAccessToken?: string;
  space?: string;
}

export const contentfulLink = (options: contentfulLinkOptions) => {
  const { accessToken, environment, preview, previewAccessToken, space } = options;

  return new HttpLink({
    uri: `https://graphql.contentful.com/content/v1/spaces/${space}/environments/${environment}`,
    headers: {
      Authorization: `Bearer ${preview ? previewAccessToken : accessToken}`,
    },
  });
};
